import type { ICartItemType } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";

/**
 * Builds the `ids` query value for `/products/cross-sell` from the cart lines.
 *
 * `inner_id` — not `id` — is the underlying product id (`id` identifies the cart
 * line). The list is de-duplicated and sorted so the same basket always produces
 * the same string: two lines of one product, or the backend returning the lines
 * in a different order, must not look like a new query and refetch.
 */
export const getCrossSellProductIds = (
  items: Pick<ICartItemType, "inner_id">[] | undefined | null,
): string =>
  Array.from(
    new Set(
      (items ?? [])
        .map((item) => item.inner_id)
        .filter((id): id is number => typeof id === "number" && id > 0),
    ),
  )
    .sort((a, b) => a - b)
    .join(",");
